import React from "react";
import styles from "./Input.module.scss";
import {
  Controller,
 type  Control,
 type  FieldValues,
type  RegisterOptions,
type  UseFormRegister,
type  Path,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

interface InputProps<T extends FieldValues = FieldValues> {
  control?: Control<T>; // Controlled component
  register?: UseFormRegister<T>; // Uncontrolled component
  validations?: RegisterOptions<T, Path<T>>; 

  name: Path<T>; // 👈 Must be a Path<T>, not string
  placeholder?: string;
  type?: string;
  [key: string]: any; // Allow extra props like className, etc.
}

const Input = <T extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  type,
  ...rest
}: InputProps<T>) => {
  const renderInput = (field: any = {}) => (
    <input
      {...field}
      {...rest}
      id={name}
      type={type || "text"}
      className={styles.inputField}
      placeholder={placeholder}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        // rules={validations}
         {...(validations ? { rules: validations } : {})}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  } else if (register) {
    const field = register(name, validations);
    return renderInput(field);
  } else {
    return renderInput(); // fallback if neither control nor register is provided
  }
};

const InputWithLabelAndError = withLabelAndError(Input);

export default InputWithLabelAndError;
export { Input };
